export const env = {
  main_uri: process.env.REACT_APP_MAIN_URI,
  api_uri: process.env.REACT_APP_API_URI,
  per_page: Number(process.env.REACT_APP_PER_PAGE),
  // AEA-55/AD-9: chave PÚBLICA RSA (PEM em base64). Pública por desenho.
  payment_secret: process.env.REACT_APP_PAYMENT_SECRET,
};
